import { Ddql, Question } from "../graphql/generated";

export const links = {
  questionLink: (
    question: Pick<Question, "id">,
    dealId: string,
    fileId?: string,
  ) => {
    if (!question || !dealId) return "";

    // for auto-opening pill popover
    if (fileId) {
      return `/deal/${dealId}/questions/${question.id}?fileid_popover_ref=${fileId}`;
    }

    return `/deal/${dealId}/questions/${question.id}`;
  },

  ddqlLink: (ddql: Pick<Ddql, "id">, dealId: string) => {
    if (!ddql || !dealId) return "";

    return `/deal/${dealId}/questions/lists/${ddql.id}`;
  },

  folderLink: (folderId: string, dealId: string) => {
    return `/deal/${dealId}/documents/folder/${folderId}`;
  },

  fileLink: (
    fileId: string,
    folderId: string,
    dealId: string,
    opts?: {
      pageIndex?: number;
      rectsOnPage?: number[][];
      sheetIndex?: number;
      cell?: string;
    },
  ) => {
    const searchParams = new URLSearchParams();

    if (opts?.pageIndex !== undefined) {
      searchParams.append("pageIndex", opts.pageIndex.toString());
    }

    if (opts?.rectsOnPage && opts.rectsOnPage.length > 0) {
      searchParams.append("rectsOnPage", JSON.stringify(opts.rectsOnPage));
    }

    if (opts?.sheetIndex !== undefined) {
      searchParams.append("sheetIndex", opts.sheetIndex.toString());
    }

    if (opts?.cell) {
      searchParams.append("cell", opts.cell);
    }

    const searchParamsString =
      searchParams.toString() !== "" ? `?${searchParams.toString()}` : "";

    return `/deal/${dealId}/documents/folder/${folderId}/file/${fileId}${searchParamsString}`;
  },

  dealAccountLink: (dealAccountId: string, dealId: string) => {
    return `/deal/${dealId}/access/account/${dealAccountId}`;
  },
};
